import React from 'react';
const ImgPicture = ({ fileName, ext, alt, className }) => {
    return (React.createElement(React.Fragment, null,
        ext === 'gif' &&
            React.createElement("img", { src: `${fileName}.${ext}?${_CACHEBUSTER}`, alt: alt }),
        ext !== 'gif' &&
            React.createElement("picture", null,
                React.createElement("source", { srcSet: `${fileName}.webp?${_CACHEBUSTER}`, type: "image/webp" }),
                React.createElement("img", { src: `${fileName}.${ext}?${_CACHEBUSTER}`, alt: alt, className: className }))));
};
ImgPicture.defaultProps = {
    ext: 'png'
};
export default ImgPicture;
